export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-amazon-b830dddb75a8e8675a22d7a61349482f.svg";